import { AnalyticsStore, ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import { reaction } from 'mobx';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';
import { UIPageStore } from 'src/common/stores/ui-page-store';

import { UitkSpacing } from 'uitk-react-spacing';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';

import { ChangeSearchForm } from './change-search-form';
import { CloseFormButton } from './close-form-button';
import { CollapsedSearchPlayback } from './collapsed-search-playback';

const LinkTracked = ClickTracker(Link);

interface CollapsibleSearchFormProps {
  analytics?: AnalyticsStore;
  searchResults?: SearchResultsStore;
  uiPage?: UIPageStore;
  context?: ContextStore;
  multiItem?: MultiItemStore;
}

export const CollapsibleSearchForm: React.FunctionComponent<CollapsibleSearchFormProps> = inject(
  'analytics',
  'searchResults',
  'uiPage',
  'context',
  'multiItem'
)(({ analytics, uiPage, searchResults, context, multiItem }) => {
  const buttonRef: any = React.useRef();
  const [expanded, setExpanded] = React.useState(searchResults?.expandForm);
  const [jsEnabled, setJsEnabled] = React.useState(false);
  const handleExpand = () => setExpanded(!expanded);
  const afterSubmit = () => setExpanded(!(context?.deviceInformation?.mobile && multiItem?.getPackageType()));

  React.useEffect(() => {
    setJsEnabled(true);
    const disposerUiPageOpenDatePickerEvent = reaction(
      () => uiPage?.openNewDatePickerEvent,
      openNewDatePickerEvent => {
        if (openNewDatePickerEvent) {
          setExpanded(true);
        }
      }
    );

    return () => {
      disposerUiPageOpenDatePickerEvent();
      searchResults?.setExpandForm(false);
    };
  }, [searchResults, uiPage?.openNewDatePickerEvent]);

  React.useEffect(() => {
    if (!expanded && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
    analytics?.trackEvent(`:${expanded ? 'ChangeSearch' : 'CloseForm'}`, 'Edit search form', null);
  }, [expanded, buttonRef]);

  return (
    <div data-stid="collapsible-playback">
      {!expanded && (
        <h2 className="is-visually-hidden">
          <LocalizedText message="hotels.infosite.availabilityWizard.changeSearch.a11yLabel" />
        </h2>
      )}
      {jsEnabled ? (
        <>
          <ChangeSearchForm isHidden={!expanded} afterSubmit={afterSubmit} />
          {!expanded && (
            <UitkTertiaryButton data-stid="form_expander" isFullWidth onClick={handleExpand} domRef={buttonRef}>
              <UitkText overflow="truncate" className="uitk-flex-basis-fullwidth">
                <CollapsedSearchPlayback />
              </UitkText>
            </UitkTertiaryButton>
          )}
        </>
      ) : (
        <LinkTracked data-stid="playback-action" linkName="Edit search form" rfrr=":ChangeSearch" to="/Hotels">
          <UitkSpacing margin={{ block: 'one' }} padding={{ inline: 'three' }}>
            <CollapsedSearchPlayback />
          </UitkSpacing>
        </LinkTracked>
      )}
      {expanded && <CloseFormButton onClick={handleExpand} />}
    </div>
  );
});
